// const baseURL = "http://10.2.1.148:8001"
// https://xlkx.xilongs.com
export default { 
  baseURL: process.env.VUE_APP_BASE_URL,
  imageUrl: process.env.VUE_APP_IMAGE_URL,
  msdsImageUrl: process.env.VUE_APP_MSDSIMAGE_URL
}